import type { ChangeEvent } from 'react';
import { forwardRef } from 'react';

import { Skeleton } from '../Skeleton';

import { StyledTextAreaWrapper, StyledTextAreaLabel, StyledTextArea, StyledTextAreaLoader } from './styles';

export type TextAreaProps = {
  className?: string;
  label?: string;
  value: string;
  onChange(value: string): void;
  placeholder: string;
  height?: number;
  isLoading?: boolean;
};

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, label, value, onChange, placeholder, height, isLoading }, ref) => {
    return (
      <StyledTextAreaWrapper data-automation="TextArea" className={className}>
        {label ? <StyledTextAreaLabel data-automation="TextAreaLabel">{label}</StyledTextAreaLabel> : null}
        {isLoading ? (
          <StyledTextAreaLoader height={height}>
            <Skeleton width="95%" height="12px" />
            <Skeleton width="85%" height="12px" />
            <Skeleton width="55%" height="12px" />
          </StyledTextAreaLoader>
        ) : (
          <StyledTextArea
            ref={ref}
            data-automation="TextAreaInput"
            value={value}
            onChange={(event: ChangeEvent<HTMLTextAreaElement>) => onChange(event.target.value)}
            placeholder={placeholder}
            height={height}
          />
        )}
      </StyledTextAreaWrapper>
    );
  }
);

export { TextArea };
